import { useEffect, useState } from 'react';
import api from '../services/api';
import searchIcon from '../assets/images/search_icon.svg';
import arrowIcon from '../assets/images/Arrow.svg';
import upwardArrowIcon from '../assets/images/upward_arrow.svg';
import "../styles/dataTable.css";
import '../styles/floatingForm.css';

const ManageUser = () => {
  const [users, setUsers] = useState([]);
  const [statuses, setStatuses] = useState([]);

  // Table
  const [search, setSearch] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  // Modal
  const [selectedUser, setSelectedUser] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);


  // Filter & Sort
  const filteredData = users.filter((item) =>
    Object.values(item)
      .join(" ")
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  if (sortField) {
    filteredData.sort((a, b) => {
      const valA = a[sortField];
      const valB = b[sortField];
      if (typeof valA === "number") {
        return sortOrder === "asc" ? valA - valB : valB - valA;
      } else {
        return sortOrder === "asc"
          ? String(valA).localeCompare(String(valB))
          : String(valB).localeCompare(String(valA));
      }
    });
  }

  const totalPages = Math.ceil(filteredData.length / entriesPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * entriesPerPage,
    currentPage * entriesPerPage
  );

  useEffect(() => {
    if (currentPage > totalPages) setCurrentPage(1);
  }, [search, entriesPerPage, totalPages]);

  useEffect(() => {
    fetchUsers();
    fetchStatuses();
  }, []);

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const fetchUsers = async () => {
    try {
      const response = await api.get(`/users/get-all`);
      const usersWithStatus = response.data.data.map(u => ({
        ...u,
        leadstatus: u.leadstatus ? Number(u.leadstatus) : 1 // default
      }));
      console.log("usersWithStatus", usersWithStatus)
      setUsers(usersWithStatus);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  const fetchStatuses = async () => {
    try {
      const response = await api.get(`/status/get-all-status`);
      const statusesWithNumberId = response.data.data.map(s => ({
        ...s,
        id: Number(s.id)
      }));
      setStatuses(statusesWithNumberId);
    } catch (error) {
      console.error('Error fetching statuses:', error);
    }
  };

const fetchUserDetails = async (id) => {
  try {
    setShowModal(true);      // 🔥 THIS LINE ADDED
    setModalLoading(true);
    setSelectedUser(null);

    const response = await api.get(`/vendor/getleaddetails/${id}`);
    console.log('User details response:', response.data);
    setSelectedUser(response.data.data);
  } catch (error) {
    console.error("Error fetching user details:", error);
  } finally {
    setModalLoading(false);
  }
};


  const handleStatusChange = async (userId, newStatusId) => {
    setUsers(prev =>
      prev.map(u =>
        u.id === userId ? { ...u, leadstatus: newStatusId } : u
      )
    );
    try {
      await api.post(`/users/leadstausupdate/${userId}`, { leadstatus: newStatusId });
      // console.log(`User ${userId} status updated to ${newStatusId}`);
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-GB", { month: "long" });
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  };

  return (
    <div style={{ padding: "20px" }}>
      {/* Table Header */}
      <div className="table-header">
        <h2 style={{ fontWeight: 700 }}>Lead List</h2>

        <div className="search-container">
          <input
            type="text"
            value={search}
            onChange={(e) => { setSearch(e.target.value); setCurrentPage(1); }}
            placeholder="Search"
          />
          <img src={searchIcon} alt="search-icon" className="search-icon" />
        </div>

        <div className="entries-container">
          <label htmlFor="noOfEntries">Show: </label>
          <select
            value={entriesPerPage}
            id="noOfEntries"
            onChange={(e) => setEntriesPerPage(Number(e.target.value))}
          >
            <option value={10}>10 Entries per page</option>
            <option value={50}>50 Entries per page</option>
            <option value={100}>100 Entries per page</option>
          </select>
        </div>
      </div>

      {/* Table */}
      <div className="table-wrapper">
        <table width="100%" cellPadding="20" className="table-no-outer-border">
          <thead>
            <tr>
              <th onClick={() => handleSort("name")}>
                <div className="name-container">
                  Name
                  <div className="sort-arrow-container">
                    <img src={upwardArrowIcon} alt="up-arrow" style={{ opacity: sortField === "name" && sortOrder === "asc" ? 1 : 0.75 }} />
                    <img src={upwardArrowIcon} alt="down-arrow" style={{ transform: 'rotateX(180deg)', marginTop: "5px", opacity: sortField === "name" && sortOrder === "desc" ? 1 : 0.5 }} />
                  </div>
                </div>
              </th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Source</th>
              <th>Media</th>
              <th>Campaign</th>
              <th>Type</th>
              <th>Page URL</th>
              <th>Enquiry Date</th>
              <th>Status</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.length > 0 ? (
              paginatedData.map((row) => (
                <tr key={row.id}>
                  <td>{row.name}</td>
                  <td>{row.email}</td>
                  <td>{row.mobile}</td>

                  <td>{row.source || "-"}</td>
                  <td>{row.media || "-"}</td>
                  <td>{row.campaign || row.campain || "-"}</td>
                  <td>{row.leadtype === "2" ? "Exclusive" : row.leadtype === "1" ? "Individual" : "-"}</td>

                  <td
                    title={row.page_url}
                  >
                    {row.pageurl || "-"}
                  </td>

                  <td>{formatDate(row.created_at)}</td>

                  <td>
                    <select
                      value={row.leadstatus}
                      onChange={(e) =>
                        handleStatusChange(row.id, Number(e.target.value))
                      }
                      style={{
                        padding: "10px 10px",
                        borderRadius: "4px",
                        background: "#BC6C25",
                        color: "#FFF",
                        border: "none",
                        fontWeight: "bold",
                      }}
                    >
                      {statuses.map((st) => (
                        <option
                          key={st.id}
                          value={st.id}
                          style={{ fontWeight: "bold", color: "#FFF" }}
                        >
                          {st.statusname}
                        </option>
                      ))}
                    </select>
                  </td>

                  <td>
                    <button
                      style={{
                        padding: "10px 10px",
                        background: "#105B3D",
                        color: "#fff",
                        fontWeight: "bold",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                      onClick={() => fetchUserDetails(row.id)}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} style={{ textAlign: "center" }}>No data found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div style={{ paddingBottom: '30px', background: '#fff' }}>
        <div style={{ padding: "30px", textAlign: "center", borderTop: '2px solid #F2F2F2', borderBottom: '2px solid #F2F2F2' }}>
          <button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} style={{ margin: "0 5px", border: "none", background: "#fff" }}>
            <img src={arrowIcon} alt="prev" style={{ opacity: currentPage === 1 ? 0.5 : 1 }} />
          </button>

          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <button key={page} onClick={() => setCurrentPage(page)} style={{ margin: "0 5px", padding: "5px 10px", background: currentPage === page ? "#D9D9D9" : "#fff", border: "none", cursor: "pointer" }}>
              {page}
            </button>
          ))}

          <button onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} style={{ margin: "0 5px", border: "none", background: "#fff" }}>
            <img src={arrowIcon} alt="next" style={{ opacity: currentPage === totalPages ? 0.5 : 1, transform: 'rotateY(180deg)' }} />
          </button>
        </div>
      </div>

{/* Modal */}
{showModal && (
  <div className="modal-overlay ">
    <div className="modal-box">
      <button className="modal-close-btn" onClick={() => {
        setShowModal(false);
        setSelectedUser(null);
      }}>×</button>

      {modalLoading ? (
        <h3 style={{ textAlign: "center", padding: "20px" }}>Loading...</h3>
      ) : (
        <>
          <h2 style={{ marginBottom: "20px",backgroundColor:"#BC6C25",padding:"10px"}}>Lead Details</h2>
          <table className="modal-table">
            <tbody>
              <tr><td><strong>Service Provider name:</strong></td><td>{selectedUser.productname_name}</td></tr>
              <tr><td><strong>Name:</strong></td><td>{selectedUser.name}</td></tr>
              <tr><td><strong>Email:</strong></td><td>{selectedUser.email}</td></tr>
              <tr><td><strong>Mobile:</strong></td><td>{selectedUser.mobile}</td></tr>
              <tr><td><strong>Departure City:</strong></td><td>{selectedUser?.dcityname}</td></tr>
              <tr><td><strong>Package:</strong></td><td>{selectedUser?.packagename ?? "-"}</td></tr>
              <tr><td><strong>Number of People:</strong></td><td>{selectedUser?.no_of_person ?? "-"}</td></tr>
              <tr><td><strong>Enquiry Date:</strong></td><td>{formatDate(selectedUser.created_at)}</td></tr>
              <tr><td><strong>Status:</strong></td><td>{statuses.find(s => s.id === selectedUser.leadstatus)?.statusname || "New Lead"}</td></tr>
              <tr><td><strong>Message:</strong></td><td>{selectedUser.message}</td></tr>
            </tbody>
          </table>
        </>
      )}
    </div>
  </div>
)}


      <style>
        {`
          .modal-overlay {
            position: fixed;
            top:0; left:0; right:0; bottom:0;
            background: rgba(0,0,0,0.75);
            display:flex; justify-content:center; align-items:center;
            z-index:9999;
          }
          .modal-box {
            background:#ffe4d0;
            padding:30px 20px 20px 20px;
            border-radius:8px;
            max-width:1000px;
            width:90%;
              color:#FBF7F4;
            box-shadow:0 4px 10px rgba(0,0,0,0.3);
            position: relative;
          }
          .modal-close-btn {
            position: absolute;
            top:20px;
            right:30px;
            background: transparent;
            border: none;
            color:#FBF7F4;
            font-size: 50px;
            font-weight: bold;
            cursor: pointer;
          }
          .modal-table {
            width: 100%;
            border-collapse: collapse;
          }
          .modal-table td {
            padding: 8px 10px;
            vertical-align: top;
            font-weight: 500;
            border-bottom: 1px solid #f1cdad;
            
          }
          .modal-table tr td:first-child {
            width: 35%;
            color: "#FFF",
          }
        `}
      </style>
    </div>
  );
};

export default ManageUser;
